import React, { useEffect,useState } from "react";
import { formatBytes } from "../../utils/mailUtils";
import ComposeToolbar from "./ComposeToolbar";
import EmailChipsInput from "./EmailChipsInput";

function ComposeForm({
  composeForm,
  onAddressChange,
  onFieldChange,
  composeAttachments,
  onRemoveAttachment,
  onSubmit,
  onSaveDraft,
  signatureList,
  composeSignatureId,
  onSignatureChange,
  defaultSignatureId,
  editorRef,
  onEditorInput,
  isDragActive,
  handleDragEnter,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  uploadingAttachment,
  attachmentInputRef,
  onAttachmentSelect,
  onOpenAttachmentPicker,
  toSuggestions,
  corporateRecipient,
  showCcField,
  onToggleCc,
  showBccField,
  onToggleBcc,
  composeCcInputRef,
  composeBccInputRef,
  composeToInputRef,
  onTypingToChange,
  toolbarHandlers,
  isMobile,
  isSending,
  onVoiceToText,
  isListening,
  onFilePaste,
  contacts = [],
  signatureHtml,
  signatureEditable = true,
}) {
  useEffect(() => {
    const node = editorRef?.current;
    
    if (!node) return;
    if (node.innerHTML !== (composeForm.body || "")) {
      node.innerHTML = composeForm.body || "";
    }
  }, [composeForm.body, editorRef]);
  

  return (
    <form onSubmit={onSubmit} className="mail-compose-form compose-modal-form">
    
      {/* TO */}
      <label className="mail-compose-label">
        <div className="mail-compose-input-row">
          <EmailChipsInput
            value={composeForm.to}
            onChange={(emails) =>
              onAddressChange({ target: { name: "to", value: emails } })
            }
            type="text"
            onTyping={(val) => onTypingToChange?.("to", val)}
            suggestions={toSuggestions}
            placeholder="recipient@krivaone.com"
            inputRef={composeToInputRef}
            contacts={contacts}
          />

          <div className="mail-compose-address-actions">
            {/* <span className="mail-compose-address-hint">
              {corporateRecipient ? "Internal delivery available" : "External recipients"}
            </span> */}
            <div className="mail-compose-address-toggle">
              {!showCcField && (
                <button type="button" onClick={() => onToggleCc?.(true)} className="mail-show-cc">
                  Cc
                </button>
              )}
              {!showBccField && (
                <button type="button" onClick={() => onToggleBcc?.(true)} className="mail-show-bcc">
                  Bcc
                </button>
              )}
            </div>
          </div>
        </div>
      </label>

      {/* CC */}
      {showCcField && (
        <label className="mail-compose-inline-field">
          <EmailChipsInput
            value={composeForm.cc}
            onChange={(emails) =>
              onAddressChange({ target: { name: "cc", value: emails } })
            }
            type="text"
            onTyping={(val) => onTypingToChange?.("cc", val)}
            placeholder="Cc recipients"
            suggestions={toSuggestions}
            inputRef={composeCcInputRef}
            contacts={contacts}
          />
          <button
            type="button"
            className="mail-compose-address-remove"
            onClick={() => onToggleCc(false)}
          >
            ×
          </button>
        </label>
      )}

      {/* BCC */}
      {showBccField && (
        <label className="mail-compose-inline-field">
              <EmailChipsInput
                value={Array.isArray(composeForm.bcc) ? composeForm.bcc : (typeof composeForm.bcc === 'string' ? (composeForm.bcc.split(/[,;\s]+/).map(s => s.trim()).filter(Boolean)) : [])}
                onChange={(emails) =>
                  onAddressChange({ target: { name: "bcc", value: emails } })
                }
                type="text"
                onTyping={(val) => onTypingToChange?.("bcc", val)}
                placeholder="Bcc recipients"
                suggestions={toSuggestions}
                inputRef={composeBccInputRef}
                contacts={contacts}
              />
          <button
            type="button"
            className="mail-compose-address-remove"
            onClick={() => onToggleBcc(false)}
          >
            ×
          </button>
        </label>
      )}

      {/* SUBJECT */}
      <label className="mail-compose-label">
        <input
        className="messsendsubject"
          type="text"
          name="subject"
          placeholder="Subject"
          value={composeForm.subject}
          onChange={onFieldChange}
        />
      </label>

      {/* MAIL STATUS */}
      <label className="mail-compose-label">
        <select
          name="mailStatus"
          value={composeForm.mailStatus}
          onChange={onFieldChange}
          required
        >
          <option value="NA">Select Mail Status</option>
          <option value="Open">Open</option>
          <option value="Action">Action</option>
          <option value="In Progress">In Progress</option>
          <option value="Closed">Closed</option>
        </select>
      </label>

     

      {/* MESSAGE */}
      <div className={`mail-compose-field ${isDragActive ? "drag-active" : ""}`}
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        
        <div
          ref={editorRef}
          className="mail-compose-editor"
            contentEditable={true}
          suppressContentEditableWarning
          onInput={onEditorInput}
          onPaste={async (e) => {
            try {
              if (!onFilePaste) return;
              const clipboardData = e.clipboardData || window.clipboardData;
              if (!clipboardData) return;

              const items = clipboardData.items;
              if (!items) return;

              const files = [];
              for (let i = 0; i < items.length; i++) {
                const it = items[i];
                if (it.kind === 'file') {
                  const f = it.getAsFile();
                  if (f) files.push(f);
                }
              }

              if (files.length) {
                e.preventDefault();
                await onFilePaste(files);
                // update editor body after paste-handling
                if (editorRef?.current) {
                  // preserve existing innerHTML (file attachments don't insert into body)
                  // but ensure compose body state is in sync via onEditorInput flow
                  onEditorInput?.({ target: editorRef.current });
                }
              }
            } catch (err) {
              console.error('Paste handling failed', err);
            }
          }}
        />
          {/* When signature is non-editable, show it as a separate read-only block */}
          {!signatureEditable && signatureHtml ? (
            <div
              className="mail-compose-signature"
              aria-hidden="true"
              dangerouslySetInnerHTML={{ __html: signatureHtml }}
            />
          ) : null}

            {!isMobile && composeAttachments.length > 0 && (
      <div className="mail-attachment-preview-list">
        {composeAttachments.map((att, i) => (
          <div key={i} className="mail-attachment-preview">
            <div>
              <div>{att.name}</div>
              <div>{formatBytes(att.size)}</div>
           </div>
            <button type="button" onClick={() => onRemoveAttachment(i)}>
              Remove
            </button>
            </div>
          ))}
        </div>
      )}


      </div>

       {/* On mobile, show attachments above the editor (chat-like); otherwise show after editor */}
      {isMobile && composeAttachments.length > 0 && (
        <div className="mail-attachment-preview-list mobile">
          {composeAttachments.map((att, i) => {
            const isImage = (att.mimeType && att.mimeType.startsWith("image/")) || /\.(png|jpe?g|gif|webp|avif)$/i.test(att.name || "");
            return (
              <div key={i} className="mail-attachment-preview mobile">
                {isImage ? (
                  <div className="mail-attachment-image-wrap">
                    <img src={att.url} alt={att.name || "image"} className="mail-attachment-image" />
                    <div className="mail-attachment-image-meta">
                      <div className="mail-attachment-name">{att.name}</div>
                      <div className="mail-attachment-size">{formatBytes(att.size)}</div>
                    </div>
                  </div>
                ) : (
                  <div className="mail-attachment-file">
                    <div>{att.name}</div>
                    <div>{formatBytes(att.size)}</div>
                  </div>
                )}
                <button type="button" onClick={() => onRemoveAttachment(i)}>
                  X
                </button>
              </div>
            );
          })}
        </div>
      )}

     
      <input
        type="file"
        ref={attachmentInputRef}
        multiple
        hidden
        onChange={onAttachmentSelect}
      />

      {/* ACTIONS */}
      <div className="mail-compose-actions">
        <button type="submit" disabled={isSending || uploadingAttachment}>
          {isSending ? "Sending..." : (composeForm.mailStatus === "NoSend" ? "Save" : "Send")}
        </button>

        <ComposeToolbar
          onAction={toolbarHandlers?.onAction}
          onOpenAttachment={onOpenAttachmentPicker}
          onVoiceToText={onVoiceToText}
          isListening={isListening}
            showCcField={showCcField}
            onToggleCc={onToggleCc}
            showBccField={showBccField}
            onToggleBcc={onToggleBcc}
          signatureList={signatureList}
          composeSignatureId={composeSignatureId}
          onSignatureChange={onSignatureChange}
          defaultSignatureId={defaultSignatureId}
          signatureHtml={signatureHtml}
        />
      </div>
{/* FLOATING SEND (MOBILE) */}
<button
  type="submit"
  className="mail-floating-send"
  disabled={isSending || uploadingAttachment}
>
  {isSending ? (
    <i className="fa-solid fa-spinner fa-spin"></i>
  ) : (composeForm.mailStatus === "NoSend" ? (
    <i className="fa-solid fa-floppy-disk"></i>
  ) : (
    <i className="fa-solid fa-paper-plane"></i>
  ))}
</button>
    </form>
  );
}

export default ComposeForm;
